// extracted by mini-css-extract-plugin
module.exports =  {"drawer":"pl__Drawer-module__drawer___PNxjL","drawer__innerPlaceholder":"pl__Drawer-module__drawer__innerPlaceholder___K9Awb"};